export const MINOR_PENTACLES: ITarotCard[] = [
  {
    id: 64,
    rank: "1",
    numeral: "I",
    name: "Ace of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/ace_of_pentacles.svg",
    wordpressId: "2521",
  },
  {
    id: 65,
    rank: "2",
    numeral: "II",
    name: "Two of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/two_of_pentacles.svg",
    wordpressId: "2524",
  },
  {
    id: 66,
    rank: "3",
    numeral: "III",
    name: "Three of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/three_of_pentacles.svg",
    wordpressId: "2529",
  },
  {
    id: 67,
    rank: "4",
    numeral: "IV",
    name: "Four of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/four_of_pentacles.svg",
    wordpressId: "2532",
  },
  {
    id: 68,
    rank: "5",
    numeral: "V",
    name: "Five of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/five_of_pentacles.svg",
    wordpressId: "2536",
  },
  {
    id: 69,
    rank: "6",
    numeral: "VI",
    name: "Six of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/six_of_pentacles.svg",
    wordpressId: "2643",
  },
  {
    id: 70,
    rank: "7",
    numeral: "VII",
    name: "Seven of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/seven_of_pentacles.svg",
    wordpressId: "2648",
  },
  {
    id: 71,
    rank: "8",
    numeral: "VIII",
    name: "Eight of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/eight_of_pentacles.svg",
    wordpressId: "2651",
  },
  {
    id: 72,
    rank: "9",
    numeral: "IX",
    name: "Nine of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/nine_of_pentacles.svg",
    wordpressId: "2656",
  },
  {
    id: 73,
    rank: "10",
    numeral: "X",
    name: "Ten of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/ten_of_pentacles.svg",
    wordpressId: "2659",
  },
  {
    id: 74,
    rank: "11",
    numeral: "XI",
    name: "Page of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/page_of_pentacles.svg",
    wordpressId: "2661",
  },
  {
    id: 75,
    rank: "12",
    numeral: "XII",
    name: "Knight of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/knight_of_pentacles.svg",
    wordpressId: "2665",
  },
  {
    id: 76,
    rank: "13",
    numeral: "XIII",
    name: "Queen of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/queen_of_pentacles.svg",
    wordpressId: "2668",
  },
  {
    id: 77,
    rank: "14",
    numeral: "XIV",
    name: "King of Pentacles",
    arcana: "pentacles",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/pentacles/king_of_pentacles.svg",
    wordpressId: "2859",
  },
];
